"use strict";
import React from "react"
import { Form, Row, Col, Input, Button, Select } from "antd"

export const DrawerInsertarClientesForm = (props) => {
    const { enviarDatosClientes, onChildrenDrawerCloseClientes, selectCatalogosUsuario } = props

    const [form] = Form.useForm();

    const onFinishInsertarClientes = (values) => {
        const nameCliente = values.nameCliente;
        const catalogo = values.selectCatalogo;

        enviarDatosClientes(nameCliente, catalogo);
    }

    return (
        <Form
            layout="vertical"
            hideRequiredMark
            onFinish={onFinishInsertarClientes}
            form={form}
        >
            <Row gutter={8}>
                <Col span={24}>
                    <Form.Item
                        hasFeedback
                        name="nameCliente"
                        label="Nombre Cliente:"
                        rules={[{ required: true, message: "Campo obligatorio." }]}
                    >
                        <Input placeholder="Por favor, escribir nombre del cliente" />
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={8}>
                <Col span={24}>
                    <Form.Item
                        hasFeedback
                        name="selectCatalogo"
                        label="Catálogo:"
                        rules={[
                            {
                                required: true,
                                message: "Campo obligatorio.",
                            },
                        ]}
                    >
                        <Select
                            showSearch
                            placeholder="Por favor, seleccionar catálogo"
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                                option.children
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                            }
                        >
                            {selectCatalogosUsuario}
                        </Select>
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={8}>
                <Col span={24}>
                    <div
                        style={{
                            textAlign: "right",
                        }}
                    >
                        <Button
                            onClick={onChildrenDrawerCloseClientes}
                            style={{ marginRight: 8 }}
                        >
                            Cancelar
                        </Button>
                        <Button type="primary" htmlType="submit">
                            Aceptar
                        </Button>
                    </div>
                </Col>
            </Row>
        </Form>
    );
};